import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-regular-svg-icons'
import { faCommentDollar, faInfo } from '@fortawesome/free-solid-svg-icons'

function BookingCategory(props) {

    function onSelect() {
        props.onSelect(props.data);
    }

    return (
        <Card style={{ marginBottom: '10px' }}>
            <Card.Header className="category-header">
                <h5>
                    {props.data.Name}
                    <Button onClick={onSelect} className='float-right' variant="choose">Välj</Button>
                </h5>
            </Card.Header>
            <Card.Body className="category-body">
                <Card.Subtitle>
                    <FontAwesomeIcon icon={faClock} style={{ marginRight: 10 }} />{props.data.DefaultMinutes} min<br />
                    <FontAwesomeIcon icon={faCommentDollar} style={{ marginRight: 10 }} />{props.data.OnlinePrice}
                </Card.Subtitle>
                <Card.Text style={{ marginTop: 10 }}>
                    <FontAwesomeIcon icon={faInfo} style={{ marginRight: 15 }} /> {props.data.OnlineDescription}
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

export default BookingCategory;